
export default {
  loginTokenKey : '__baw_loginToken',
  btnAuthKey : '__baw_btnAuth',

  //缓存登录信息
  addToken : function(val){
    this.delToken()
    window.localStorage.setItem(this.loginTokenKey, val)
  },
  updateToken : function(val){
    this.addToken(val)
  },
  getToken : function(){
    return window.localStorage.getItem(this.loginTokenKey)
  },
  delToken : function(){
    return window.localStorage.removeItem(this.loginTokenKey)
  },
  
  //缓存操作按钮权限信息
  addBtnAuth : function(val){
    this.delBtnAuth()
    window.localStorage.setItem(this.btnAuthKey, val)
  },
  updateBtnAuth : function(val){
    this.addBtnAuth(val)
  },
  getBtnAuth : function(){
    return window.localStorage.getItem(this.btnAuthKey)
  },
  delBtnAuth : function(){
    return window.localStorage.removeItem(this.btnAuthKey)
  }
}



// WEBPACK FOOTER //
// ./src/util/baw.js